const middleware = {}

middleware['layout'] = require('../src/middleware/layout.js')
middleware['layout'] = middleware['layout'].default || middleware['layout']

export default middleware
